/**
 * Class representing an alternative for a question.
 */
export class Alternative {
    /**
     * Create an alternative for a question.
     * @param {Alternative} alternative - The question alternative
     * @param {Number} alternative.alternativeId - The alternative id.
     * @param {string} alternative.text - The text for the alternative.
     * @param {Number} alternative.orderNo - Determines sequence for the alternatives, starting from the lowest.
     * @param {boolean} alternative.isDeleted - true if the alternative should be deleted.
     */
    constructor(alternative) {
        this.alternativeId = alternative.alternativeId;
        this.text = alternative.text;
        this.orderNo = alternative.orderNo;
        this.isDeleted = alternative.isDeleted;
    }
}
